import { Box, Button, TextField } from '@mui/material'
import React from 'react'
import SendIcon from '@mui/icons-material/Send'
import Stack from '@mui/material/Stack'

export const Form = () => {
  return (
    // '50ch'
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { 
              width: {
                xs: '100%',
                md: '50ch',
              } 
            },
          }}
          autoComplete="off"
          action='https://formsubmit.co/davidsibanda776@gmail.com'
          method="POST"
          data-netlify="true"
        >
            <div>
              <TextField 
                name="name" 
                label="Name" 
                type="text"
                variant="outlined" 
                margin="normal" 
                required 
                />
            </div>
            <div>
              <TextField 
                name="email" 
                label="Email" 
                type="email" 
                variant="outlined" 
                margin="normal" 
                required
                />
            </div>
            <div>
              <TextField 
                name="_subject" 
                label="Subject(optional)" 
                variant="outlined" 
                margin="normal" 
              />
            </div>
            <div>
              <TextField 
                name="message" 
                label="Message" 
                variant="outlined" 
                multiline rows={5} 
                margin="normal" 
                required
              />
            </div>
            <input 
              type="hidden" 
              name="_next" 
              value="http://davecodesstuff.netlify.app/#contact"
            />
            <input 
              type="hidden" 
              name="_captcha" 
              value="false"
            />
            <Stack direction="row" spacing={2} sx={{my:2}}>
                <Button 
                  variant="contained" 
                  type='submit' 
                  endIcon={<SendIcon />} 
                  sx={{mt:1}}>
                    Send
                </Button>
            </Stack>
        </Box> 
  )
}
